 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLCH001 from '@/components/xhtml/ch001'
 import XHTMLCH002 from '@/components/xhtml/ch002'
 import XHTMLCH003 from '@/components/xhtml/ch003'
 import XHTMLCH004 from '@/components/xhtml/ch004'
 import XHTMLCH005 from '@/components/xhtml/ch005'
 import XHTMLCH006 from '@/components/xhtml/ch006'
 import XHTMLCH007 from '@/components/xhtml/ch007'
 import XHTMLCH008 from '@/components/xhtml/ch008'
 import XHTMLCH009 from '@/components/xhtml/ch009'
 import XHTMLCH010 from '@/components/xhtml/ch010'
 import XHTMLCH011 from '@/components/xhtml/ch011'
 import XHTMLCH012 from '@/components/xhtml/ch012'
 import XHTMLCH013 from '@/components/xhtml/ch013'
 import XHTMLCH014 from '@/components/xhtml/ch014'
 import XHTMLCH015 from '@/components/xhtml/ch015'
 import XHTMLCH016 from '@/components/xhtml/ch016'
 import XHTMLCH017 from '@/components/xhtml/ch017'
 import XHTMLCH018 from '@/components/xhtml/ch018'
 import XHTMLCH019 from '@/components/xhtml/ch019'
 import XHTMLCH020 from '@/components/xhtml/ch020'
 import XHTMLCH021 from '@/components/xhtml/ch021'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/ch005",
 			"name" : "xhtml/ch005",
 			"component" : XHTMLCH005
 		},
 		{
 			"path" : "/xhtml/ch006",
 			"name" : "xhtml/ch006",
 			"component" : XHTMLCH006
 		},
 		{
 			"path" : "/xhtml/ch007",
 			"name" : "xhtml/ch007",
 			"component" : XHTMLCH007
 		},
 		{
 			"path" : "/xhtml/ch008",
 			"name" : "xhtml/ch008",
 			"component" : XHTMLCH008
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js